var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "12px",
    viewBox: "0 0 15 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Minor / International") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.450980 0 0 0 0 0.505882 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-/-06-Courses",
    transform: "translate(0.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Minor-/-International",
    transform: "translate(0.000000, 3.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.73833333,8.784 L2.73833333,10.6573333 C2.73833333,11.144 3.005,11.5973333 3.43166667,11.8306667 L6.765,13.6506667 C7.165,13.8706667 7.645,13.8706667 8.045,13.6506667 L11.3783333,11.8306667 C11.805,11.5973333 12.0716667,11.144 12.0716667,10.6573333 L12.0716667,8.784 L8.045,10.984 C7.645,11.204 7.165,11.204 6.765,10.984 L2.73833333,8.784 Z M6.765,2.344 L1.145,5.41066667 C0.685,5.664 0.685,6.33066667 1.145,6.584 L6.765,9.65066667 C7.165,9.87066667 7.645,9.87066667 8.045,9.65066667 L13.405,6.724 L13.405,10.664 C13.405,11.0306667 13.705,11.3306667 14.0716667,11.3306667 C14.4383333,11.3306667 14.7383333,11.0306667 14.7383333,10.664 L14.7383333,6.39066667 C14.7383333,6.144 14.605,5.924 14.3916667,5.804 L8.045,2.344 C7.645,2.13066667 7.165,2.13066667 6.765,2.344 Z",
    id: "Mask",
    fill: "#C4CDD5",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradCap);
export default __webpack_public_path__ + "static/media/grad-cap.f2c417da.svg";
export { ForwardRef as ReactComponent };